import { IScrollablePaneProps, ScrollablePane } from '@fluentui/react/lib/ScrollablePane';

export interface IPScrollablePaneProps extends IScrollablePaneProps {}
export { ScrollbarVisibility as IPScrollbarVisibility } from '@fluentui/react/lib/ScrollablePane';

export const IPScrollablePane = (props: IPScrollablePaneProps) => {
  return <ScrollablePane {...props} />;
};
